'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _list = require('../list');

var _list2 = _interopRequireDefault(_list);

var _modifiers = require('../../../../../modifiers');

var _modifiers2 = _interopRequireDefault(_modifiers);

var _element = require('../../../../element');

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/* eslint-disable-next-line import/no-cycle */


var MenuListItem = function MenuListItem(_ref) {
  var children = _ref.children,
      active = _ref.active,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['children', 'active', 'className']);

  if (typeof children === 'string') {
    return _react2.default.createElement('li', null, _react2.default.createElement(_element2.default, _extends({
      className: (0, _classnames2.default)(className, {
        'is-active': active
      })
    }, props), children));
  }

  if (_react2.default.Children.only(children).type === _list2.default) {
    var child = _react2.default.Children.only(children);

    return _react2.default.createElement('li', null, _react2.default.createElement(_element2.default, _extends({
      className: (0, _classnames2.default)(className, {
        'is-active': active
      })
    }, props), child.props.title), _react2.default.cloneElement(child, {
      title: null
    }));
  }

  return _react2.default.createElement('li', null, children);
};

MenuListItem.propTypes = _extends({}, _modifiers2.default.propTypes, {
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  active: _propTypes2.default.bool,
  renderAs: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
});
MenuListItem.defaultProps = _extends({}, _modifiers2.default.defaultProps, {
  className: '',
  children: null,
  active: false,
  renderAs: 'a'
});
exports.default = MenuListItem;